// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-container{height:100%!important;width:100%!important;max-width:100%!important;background-color:#f8f8f8}", ""]);
// Exports
module.exports = exports;
